/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { representativesList } from "../../funcs/representativesList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListRepresentativesRequest$inboundSchema,
};

export const tool$representativesList: ToolDefinition<typeof args> = {
  name: "representatives-list",
  description:
    `A Moov account may have multiple representatives depending on the associated business's ownership and management structure. 
You can use this method to list all the representatives for a given Moov account. 
Note that Moov accounts associated with an individual do not have representatives. 
Read our [business representatives guide](https://docs.moov.io/guides/accounts/requirements/business-representatives/) to learn more.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/representatives.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await representativesList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
